import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../other/shared.service';
import { BaseService, BaseServiceSZ } from '../other/baseService';
import { PerformPurchaseModel } from 'src/app/models/classes/payment-devices/sure-pay/perform-purchase-model';
import { PerformRefundModel } from 'src/app/models/classes/payment-devices/sure-pay/perform-refund-model';
import { AllSurePayResponse } from 'src/app/models/classes/payment-devices/sure-pay/all-sure-pay-response';
import { SurePayResponseCode } from 'src/app/models/enums/sure-pay-result';
import { TranslateService } from '@ngx-translate/core';
import { SurePayTransactionType } from 'src/app/models/enums/sure-pay-transaction-type';
import { CheckConnectionModel } from 'src/app/models/classes/payment-devices/sure-pay/check-connection-model';
@Injectable({
  providedIn: 'root',
})
export class SurePayService extends BaseService {
  private surePayUrl;

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private _BaseService: BaseServiceSZ,
    private sharedService: SharedService
  ) {
    super();
    this.surePayUrl = this.sharedService.SurePayUrl;
  }

  CheckConnection(model: CheckConnectionModel): Observable<string> {
    return this.http
      .post<string>(
        this.surePayUrl + 'CheckConnection',
        model,
        this.sharedService.getHeaders()
      )
      .pipe(
        tap((res) => {
          this._BaseService.log('CheckConnection');
        }),
        catchError(this._BaseService.handleError<string>('CheckConnection'))
      );
  }

  PerformPurchase(model: PerformPurchaseModel): Observable<string> {
    return this.http
      .post<string>(
        this.surePayUrl + 'PerformPurchase',
        model,
        this.sharedService.getHeaders()
      )
      .pipe(
        tap((res) => {
          this._BaseService.log('PerformPurchase');
        }),
        catchError(this._BaseService.handleError<string>('PerformPurchase'))
      );
  }

  PerformRefund(model: PerformRefundModel): Observable<string> {
    return this.http
      .post<string>(
        this.surePayUrl + 'PerformRefund',
        model,
        this.sharedService.getHeaders()
      )
      .pipe(
        tap((res) => {
          this._BaseService.log('PerformRefund');
        }),
        catchError(this._BaseService.handleError<string>('PerformRefund'))
      );
  }

  MapResponse(response: string): string[] {
    response = response.replace('"', '');
    response = response.replace('Result', '"Result"');
    response = response.replace(': ', ':"');
    response = response.replace('}', '"}');

    let allSurePayResponse: AllSurePayResponse = JSON.parse(response);
    var allSurePayResponseSplited = allSurePayResponse.Result.split('|');
    return allSurePayResponseSplited;
  }

  HandleResponseMessage(
    responseCode: SurePayResponseCode,
    transactionType: SurePayTransactionType
  ) {
    switch (responseCode) {
      case SurePayResponseCode.Success:
        switch (transactionType) {
          case SurePayTransactionType.Purchase:
            this.sharedService.ToastrSuccess(
              this.translateService.instant(
                'PaymentTransactionDoneSuccessfully.'
              )
            );
            break;
          case SurePayTransactionType.Refund:
            this.sharedService.ToastrSuccess(
              this.translateService.instant(
                'RefundTransactionDoneSuccessfully.'
              )
            );
            break;
          case SurePayTransactionType.CheckConnection:
            this.sharedService.ToastrSuccess(
              this.translateService.instant('DeviceConnected.')
            );
            break;
          default:
            break;
        }
        break;
      case SurePayResponseCode.Declined:
        this.sharedService.ToastrError(
          this.translateService.instant('Sorry!TransactionDeclined!')
        );
        break;
      case SurePayResponseCode.ERR_COM_PORT_NOT_OPENED:
        this.sharedService.ToastrError(
          this.translateService.instant(
            'Sorry!ThereIsErrorConnectingTheDevice.PleaseCheckDeviceConnectionAndTryAgain!'
          )
        );
        break;
      case SurePayResponseCode.ERR_FAILED_TO_SEND_DATA_TO_COM_PORT:
      case SurePayResponseCode.ERR_FAILED_TO_RECEIVE_DATA_FROM_COM_PORT:
        this.sharedService.ToastrError(
          this.translateService.instant(
            'Sorry!ThereIsErrorInTheDevice.PleaseOpenPaymentAppOnDevice!'
          )
        );
        break;

      default:
        switch (transactionType) {
          case SurePayTransactionType.Purchase:
            this.sharedService.ToastrError(
              this.translateService.instant('Sorry!ErrorHappenInPayment!')
            );
            break;
          case SurePayTransactionType.Refund:
            this.sharedService.ToastrError(
              this.translateService.instant('Sorry!ErrorHappenInRefund!')
            );
            break;
          case SurePayTransactionType.CheckConnection:
            this.sharedService.ToastrError(
              this.translateService.instant('DeviceNotConnected!')
            );
            break;
          default:
            this.sharedService.ToastrError(
              this.translateService.instant('Sorry!TheIsErrorInDevice!')
            );
            break;
        }

        break;
    }
  }
}
